import { FaSistrix, FaBan } from "react-icons/fa";
import Button from "../Buttons/Button";
import CustomInput from "../Inputs/CustomInput";

type ListSearchControlsProps = {
  searchLabel?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  onClear: () => void;
};

export const ListSearchControls = (props: ListSearchControlsProps) => {
  const {
    searchLabel = "Buscar por nombre",
    searchValue,
    onSearchChange,
    onSearch,
    onClear,
  } = props;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 xl:grid-cols-7 gap-4 items-end">
      <CustomInput
        label={searchLabel}
        type="text"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <div>
        <Button size="medium" className="mb-2 mr-2" onClick={onSearch} color="primary">
          <FaSistrix />
        </Button>
        <Button size="medium" className="mb-2" onClick={onClear} color="secondary">
          <FaBan />
        </Button>
      </div>
    </div>
  );
};
